'use strict';

angular.module('licensure.services')
    .factory('LicenseCategoryCertificationAttributes', ['$http', '$q', function ($http, $q) {
        return {
            get: function (license_category_id) {
                var d = $q.defer();

                $http
                    .get(apiLocation + '/api/licensecategorycertificationattributes', {
                        params: {
                            license_category_id: license_category_id
                        }
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                        // handle error
                    });

                return d.promise;
            },

            save: function (license_category_certification_attribute, license_id) {
                var d = $q.defer();

                var method = 'POST';
                var url = apiLocation + '/api/licensecategorycertificationattributes/';
                if (!isUndefined(license_category_certification_attribute.id)) {
                    method = 'PUT'
                    url += license_category_certification_attribute.id
                }

                $http({
                    method: method,
                    url: url,
                    data: {
                        license_category_certification_attribute: license_category_certification_attribute,
                        license_id: license_id
                    }
                })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            }
        }
    }])
;